import request from '../utils/request';
import uploadMultipart from '../utils/uploadMultipart';
import { API_PATHS } from './config';

const { NEWS } = API_PATHS;

const buildQuery = (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== '') {
            qs.set(key, String(value));
        }
    });
    const str = qs.toString();
    return str ? `?${str}` : '';
};

/** 资讯分类 */
export const listNewsCategories = async () => {
    const data = await request(NEWS.CATEGORIES, { method: 'GET' });
    return Array.isArray(data) ? data : [];
};

/** 资讯列表 */
export const listNews = ({ category, keyword, page = 1, size = 20 } = {}) =>
    request(`${NEWS.LIST}${buildQuery({ category, keyword, page, size })}`, { method: 'GET' });

/** 个性化 Feed */
export const getNewsFeed = ({ page = 1, size = 20 } = {}) =>
    request(`${NEWS.FEED}${buildQuery({ page, size })}`, { method: 'GET' });

/** 资讯详情 */
export const getNewsDetail = (id) =>
    request(`${NEWS.DETAIL}/${id}`, { method: 'GET' });

/** 我的订阅 */
export const listNewsSubscriptions = async () => {
    const data = await request(NEWS.SUBSCRIPTION, { method: 'GET' });
    return Array.isArray(data) ? data : [];
};

/** 新增订阅 */
export const addNewsSubscription = (payload) =>
    request(NEWS.SUBSCRIPTION, {
        method: 'POST',
        body: JSON.stringify(payload),
    });

/** 取消订阅 */
export const removeNewsSubscription = (id) =>
    request(`${NEWS.SUBSCRIPTION_REMOVE}/${id}`, { method: 'POST' });

/** 导入资讯 CSV（仅超管） */
export const importNewsCsv = (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return uploadMultipart(NEWS.ADMIN_IMPORT, fd);
};
